var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9166 12.9167H25.4166C24.9746 12.9167 24.5506 12.7411 24.2381 12.4285C23.9255 12.116 23.7499 11.692 23.7499 11.25V3.75M32.9166 12.9167V34.5833C32.9166 35.0254 32.741 35.4493 32.4284 35.7618C32.1159 36.0744 31.6919 36.25 31.2499 36.25H8.74992C8.30789 36.25 7.88397 36.0744 7.57141 35.7618C7.25885 35.4493 7.08325 35.0254 7.08325 34.5833V5.41667C7.08325 4.97464 7.25885 4.55072 7.57141 4.23816C7.88397 3.92559 8.30789 3.75 8.74992 3.75H23.7499M32.9166 12.9167L23.7499 3.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6926 20.4452H24.9493V27.916M24.9493 24.1802H27.3918M11.3085 27.9019V20.4302H13.8226C14.4876 20.43 15.1255 20.6939 15.5959 21.164C16.0663 21.6341 16.3307 22.2718 16.331 22.9368C16.3312 23.6019 16.0672 24.2398 15.5971 24.7102C15.127 25.1806 14.4893 25.445 13.8243 25.4452H11.3076M18.1285 27.916V20.416H19.4001C20.3947 20.416 21.3485 20.8111 22.0518 21.5144C22.755 22.2176 23.1501 23.1715 23.1501 24.166C23.1501 25.1606 22.755 26.1144 22.0518 26.8177C21.3485 27.5209 20.3947 27.916 19.4001 27.916H18.1285Z",
    stroke: "#E70707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.07e440851b173352922da54233b2f005.svg";
export { ForwardRef as ReactComponent };